import { type ConfigItem, FactSetWidget } from "./FactsetWidget";

type AssetListProps = {
  identifiers: ReadonlyArray<string>;
  symbolLinkClick?: (event: any) => void;
};

export function AssetsList({ identifiers, symbolLinkClick }: AssetListProps) {
  const config = [
    {
      type: "attribute",
      key: "identifiers",
      value: identifiers,
    },
  ] as ConfigItem[];

  if (symbolLinkClick) {
    config.push({ type: "event", key: "row-click", value: symbolLinkClick });
  }

  return <FactSetWidget config={config} widget="assets-list" />;
}
